import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

export const QUEUED_UPLOAD_STATUS = {
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  FAILED: 'failed',
};

const UPLOAD_DONE_PERCENT = 100;

const findItem = (state, id) => state.items.find((item) => item.id === id);

export const FileUploadQueueSlice = createSlice({
  name: 'FileUploadQueue',
  initialState,
  reducers: {
    addQueuedUploads(state, action) {
      state.items.push(
        ...action.payload.map((item) => ({
          ...item,
          status: QUEUED_UPLOAD_STATUS.UPLOADING,
          percent: 0,
        }))
      );
    },
    setQueuedUploadPercent(state, action) {
      const item = findItem(state, action.payload.id);
      if (item) {
        item.percent = action.payload.percent;
      }
    },
    setQueuedUploadStatus(state, action) {
      const item = findItem(state, action.payload.id);
      if (item) {
        item.status = action.payload.status;
      }
    },
    removeQueuedUpload(state, action) {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    toggleUploadQueueMinimized(state) {
      state.isMinimized = !state.isMinimized;
    },
    clearUploadQueue() {
      return { ...initialState };
    },
  },
});

export const {
  addQueuedUploads,
  setQueuedUploadPercent,
  setQueuedUploadStatus,
  removeQueuedUpload,
  toggleUploadQueueMinimized,
  clearUploadQueue,
} = FileUploadQueueSlice.actions;

export const selectUploadQueueItems = (state) =>
  state.FileUploadQueueSlice.items;

export const selectIsUploadQueueMinimized = (state) =>
  state.FileUploadQueueSlice.isMinimized;

export const isQueuedUploadInProgress = (item) =>
  item.status === QUEUED_UPLOAD_STATUS.UPLOADING;

// At 100% every part is in and only the completion is left, which can no
// longer be cancelled.
export const isQueuedUploadCancellable = (item) =>
  isQueuedUploadInProgress(item) && item.percent < UPLOAD_DONE_PERCENT;

export const selectHasUploadsInProgress = (state) =>
  selectUploadQueueItems(state).some(isQueuedUploadInProgress);

export default FileUploadQueueSlice.reducer;
